<script>
    import GameTileRow from './GameTileRow.svelte';
    import GameOver from './GameOver.svelte';
    import Timer from './Timer.svelte';

    import { timer } from './gameState.js';
    import { endurance_start_time } from './gameState.js';
    import { timer_started} from './gameState.js';
    import { is_game_over} from './gameState.js';

    $endurance_start_time = 30;
    $is_game_over = false;
    $timer_started = false;

    export let isTimeAttack = true;

    let score = 0;
    let scoreAtDeath = 0;
    let highscore = 0;
    let isHighscore = false;
    let tilePositions = [];
    let keyPositions = ['q','w','e','r'];
    let waitingForFirstPress = true;

    //Retrieve highscore from memory.
    if(localStorage['highscore']) {
        highscore = localStorage['highscore'];
    }

    //Generate starting level.
    for(let i = 0; i < 4; i++) {
        tilePositions.push(generateRandomTileOrder())
    }

    function logKeyPress (e) {
		console.log("Key Pressed: " + e.key);
        if(keyPositions.includes(e.key) && !$is_game_over) {
            $timer_started = true;
            let newTiles = generateRandomTileOrder();
            let tilePositionsOfLast = tilePositions.pop();
            for(let i = 0; i < tilePositionsOfLast.length; i++) {
                if(tilePositionsOfLast[i] == 1) {
                    if(e.key == keyPositions[i]) {
                        score++;
                    }
                    else {
                        gameOver();
                    }
                }
            }
            tilePositions = [newTiles, ...tilePositions];
        }
	}

    function generateRandomTileOrder() {
        let newTileArray = [0,0,0,0];
        let index = getRandomInt(4);
        newTileArray[index] = 1;
        return newTileArray;
    }

    function getRandomInt(max) {
        return Math.floor(Math.random() * max);
    }

    function startNewGame() {
        getNewBoard();
        timer.update((n) => $endurance_start_time);
        waitingForFirstPress = true;
        $is_game_over = false;
        $timer_started = false;
        isHighscore = false;
    }
    
    function getNewBoard() {
        tilePositions = [];
        for(let i = 0; i < 4; i++) {
            tilePositions.push(generateRandomTileOrder())
        }
    }

    function gameOver() {
        //GAME OVER.
        $is_game_over = true;
        scoreAtDeath = score;

        //Save Highscore.
        if(score > highscore) {
            isHighscore = true;
            highscore = score;
            localStorage['highscore'] = highscore;
        }

        //Reset score.
        score = 0;
    }

	document.onkeydown = logKeyPress;
</script>

<div>
    <span id="score">Score: {score}</span>
    <span id="highscore">High Score: {highscore}</span>
    {#if isTimeAttack}
        <Timer on:timerended={gameOver}/>
    {/if}
    {#each tilePositions as tileRow}
        <GameTileRow {tileRow} />
    {/each}
    {#if $is_game_over}
        <GameOver {isHighscore} score={scoreAtDeath} on:restart={startNewGame}/>
    {/if}
</div>

<style>
    div {
        display: flex;
        width:100%;
        height:80%;
        margin: 0px;
        flex-direction: column;
    }

    #score {
        position: absolute;
        left:10px;
        top:10px;
        font-size: 18px;
        font-weight: bold;
        color:goldenrod;
    }

    #highscore {
        position: absolute;
        right:10px;
        top:10px;
        font-size: 18px;
        font-weight: bold;
        color:goldenrod;
    }
</style>